// src/components/NoAccessesView.jsx
import React from 'react';

/**
 * Renders an empty‑state message when the user has no active accesses.
 *
 * Props (all optional):
 *  - title        (string)
 *  - subtitle     (string)
 *  - hint         (string)
 */
export default function NoAccessesView({
  title = 'No Active Accesses',
  subtitle = "You currently don't have any active asset accesses. Access is granted when you open a special link containing an access key.",
  hint = 'Accesses are shared as links — check your e‑mail or other communication channels.'
}) {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center p-4 text-center"
         style={{ minHeight: '70vh' }}>
      {/* Icon circle */}
      <div
        className="d-flex justify-content-center align-items-center mb-4"
        style={{
          width: 140,
          height: 140,
          borderRadius: '50%',
          background: '#f4f5f7'
        }}
      >
        <i className="bi bi-key" style={{ fontSize: '3rem', color: '#8a9099' }} />
      </div>

      {/* Headline */}
      <h4 className="fw-semibold mb-3">{title}</h4>

      {/* Explanation */}
      <p className="text-muted mb-4" style={{ maxWidth: 320 }}>
        {subtitle}
      </p>

      {/* Hint / secondary text */}
      <p className="text-secondary small mb-0" style={{ maxWidth: 320 }}>
        {hint}
      </p>
    </div>
  );
}
